import PortalIdParser from 'PortalIdParser';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_GROUPED_REVISIONS_FIELD = 'automation_ui_canvas_getGroupedRevisions';
export const GET_GROUPED_REVISIONS_FIELD_POLICY = {
  keyArgs: ['flowId', 'startTimestamp'],
  merge(existing, incoming) {
    if (!existing ||
    // This means another revision has been created which resets the groupId to 0.
    incoming.results[0].groupId === 0 && existing.results[0].version !== incoming.results[0].version) {
      return Object.assign({}, incoming);
    }
    const mergedResults = [...existing.results, ...incoming.results];
    const uniqueResults = [];
    const uniqueVersions = new Set();
    // only merge unique versions
    mergedResults.forEach(groupedVersion => {
      if (!uniqueVersions.has(groupedVersion.version)) {
        uniqueVersions.add(groupedVersion.version);
        uniqueResults.push(groupedVersion);
      }
    });
    return Object.assign({}, incoming, {
      results: uniqueResults
    });
  }
};
export const FETCH_GROUPED_REVISIONS = registerQuery({
  fieldName: GET_GROUPED_REVISIONS_FIELD,
  args: ['flowId'],
  fetcher({
    flowId,
    startTimestamp,
    after,
    lastGroupId = 0
  }) {
    return http.post(`automationmanagement/v1/revision/${flowId}/grouped-by-canvas-compatibility?portalId=${PortalIdParser.get()}`, {
      data: {
        flowId,
        startTimestamp,
        lastGroupId,
        limit: 25,
        after
      }
    });
  }
});